import {apiActionImproved} from "@/api.ts";
import StarsRating from "@/profile/cards/StarsRating.tsx";
import services from "@/services";
import {Review} from "@/types";
import queryKeys from "@/utilities/queryKeys.ts";
import {Card, CardBody} from "@heroui/react";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";

export const Route = createFileRoute('/_app/clubs/$club_uid/reviews')({
    component: RouteComponent,
})

function RouteComponent() {
    const queryClient = useQueryClient();
    const params = useParams({strict: false})

    const reviewsQuery = useQuery<Review[]>({
        queryKey: queryKeys.reviews(params.club_uid),
        queryFn:  async () => services.reviews.index(params.club_uid!),
        enabled:  !!params.club_uid,
    })

    const deleteReview = (post: any) => {
        if (!window.confirm('Delete this user?')) {
            return;
        }
        apiActionImproved('players-delete', {
            uid: post.uid,
        }).then(() => {
            queryClient.invalidateQueries({queryKey: queryKeys.users()})
        });
    };

    return (
        <div className={"p-4"}>
            <h2 className={"text-2xl mb-4"}>Club Reviews</h2>

            {(reviewsQuery.data || []).map((review: any) => (
                <Card key={review.uid} className="mb-4">
                    <CardBody>
                        <div className={"flex items-center justify-between mb-2"}>
                            <StarsRating value={Math.round(review.rating_percent / 20)} />
                            <div className="text-sm">{review.created_at.replace('T', ' ').replace(/\..*/, '')}</div>
                        </div>
                        {review.comment && <div className="italic">{review.comment}</div>}
                    </CardBody>
                </Card>
            ))}
        </div>
    )
}
